var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Inset } from "syf-component-library/ui/spacing";
import analyticsHandler from "./helpers";
import { CenteredBody, NoStatementsContainer, NoStatementsTitle, } from "./subcomponents";
import endPoints from "../../../const/endpoints";
import icons from "../../../const/icons";
import { useAccountSummary, useStatementsEnrollment, } from "../../../const/syfApiQueries";
import { useStatementsContext } from "../../../context/statementsContext";
import { useConfig } from "../../../hooks/useConfig";
import { CustomStatementImage } from "../EnrollCard/subcomponents";
var NoStatementsSection = function (_a) {
    var _b, _c;
    var isNoRecentStatements = _a.isNoRecentStatements, _d = _a.isStatementError, isStatementError = _d === void 0 ? false : _d;
    var assets = useConfig().hosts.assets;
    var t = useTranslation().t;
    var accountId = useStatementsContext().state.accountId;
    var accountSummary = useAccountSummary(accountId).data;
    var enrollmentStatusData = useStatementsEnrollment(accountId).data;
    var statementLogo = isStatementError
        ? icons.statementsDownIcon
        : icons.noStatementIcon;
    var checkIsNoRecentStatements = function () {
        return isNoRecentStatements
            ? t("modal.noStatements.notRecent")
            : t("modal.noStatements.notAvailable");
    };
    var noStatementsDescription = isStatementError
        ? t("modal.statementsDown.description")
        : checkIsNoRecentStatements();
    useEffect(function () {
        var _a, _b;
        analyticsHandler({
            clientId: (_a = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product.clientId) !== null && _a !== void 0 ? _a : "",
            product: (_b = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product) === null || _b === void 0 ? void 0 : _b.type,
            isStatementError: isStatementError,
            noStatementsTitle: isStatementError
                ? t("modal.statementsDown.title", { lng: "en" })
                : t("modal.noStatements.title", { lng: "en" }),
            statementsEnrollmentType: enrollmentStatusData === null || enrollmentStatusData === void 0 ? void 0 : enrollmentStatusData.enrollmentType,
        });
    }, [
        isStatementError,
        enrollmentStatusData,
        (_b = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product) === null || _b === void 0 ? void 0 : _b.clientId,
        (_c = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product) === null || _c === void 0 ? void 0 : _c.type,
        t,
    ]);
    return (_jsxs(NoStatementsContainer, __assign({ "data-cy": "noStatementsSection" }, { children: [_jsx(Inset, { top: "medium" }), _jsx("div", { children: _jsx(CustomStatementImage, { src: "".concat(assets).concat(endPoints.digitalAssets).concat(statementLogo), width: "560px", height: "200px", alt: "" }) }), _jsx(Inset, { top: "large" }), _jsx(NoStatementsTitle, __assign({ weight: "bold" }, { children: isStatementError
                    ? t("modal.statementsDown.title")
                    : t("modal.noStatements.title") })), _jsx(Inset, { top: "large" }), _jsx(CenteredBody, { children: noStatementsDescription }), _jsx(Inset, { top: "large" })] })));
};
export default NoStatementsSection;
